import React from 'react';
import ReactDOM from 'react-dom';
import { Redirect, BrowserRouter, Switch, Route } from 'react-router-dom';
import './index.css';
import HomePage from './views/HomePage/HomePage';
import ContactUsPage from './views/ContactUsPage/ContactUsPage';
import CalculationsPage from './views/CalculationsPage/CalculationsPage';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Switch>
        <Route component={HomePage}>
          <Route exact path="/" component={HomePage} />
          <Route path="/about" component={HomePage} />
          <Route path="/gallery" component={HomePage} />
          <Route path="/resortinfo" component={HomePage} />
          <Route path="/calendar" component={HomePage} />
          <Route path="/contactus" component={ContactUsPage} />
          <Route path="/calculations" component={CalculationsPage} />
        </Route>
        <Redirect to="/calculations" />
      </Switch>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
